// eslint-disable-next-line import/prefer-default-export
export const TOGGLE_THEME = 'TOGGLE_THEME';
